module.exports = __webpack_public_path__ + "ecb4b0236c5d72086edcb5807f8c0763.png";